__turbopack_context__.v({
  "checkbox": "checkbox-module__ONjMaa__checkbox",
  "checkbox_description": "checkbox-module__ONjMaa__checkbox_description",
});
